import {
	ATTRIBUTES,
	publish,
	PUB_SUB_EVENTS,
	SELECTORS,
} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {
	addItemsToCart,
	getDOMCartSectionApiIds,
	renderResponseToCartDrawer,
} from '@/scripts/core/cart-functions'

export class ProductGiftForm extends UcoastEl {
	static htmlSelector = 'product-gift-form'

	form: HTMLFormElement
	submitButton: HTMLButtonElement
	contactDetailInputs: NodeListOf<HTMLInputElement>
	variantInputs?: NodeListOf<HTMLInputElement>
	recipientControlInput?: HTMLInputElement
	timezoneOffsetInput?: HTMLInputElement
	error?: boolean
	constructor() {
		super()
		this.form = q.rs('form', this)
		this.submitButton = q.rs('button[type="submit"]', this)
		this.variantInputs = this.querySelectorAll(
			'.product-gift-form__variant-input'
		)
		this.contactDetailInputs = q.rl('.product-gift-form__input', this)
		this.recipientControlInput = q.os(
			'[data-uc-gift-recipient-control]',
			this
		)
		this.timezoneOffsetInput = q.os('[data-uc-gift-recipient-offset]', this)

		if (this.timezoneOffsetInput) {
			this.timezoneOffsetInput.value = new Date()
				.getTimezoneOffset()
				.toString()
		}

		this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

		this.contactDetailInputs.forEach((input) => {
			input.addEventListener('input', this.onChangeDetails.bind(this))
		})
		if (this.variantInputs.length) {
			this.variantInputs.forEach((variantInput) => {
				variantInput.addEventListener(
					'click',
					this.onChangeVariant.bind(this)
				)
			})
		}
	}

	onChangeVariant(e: Event) {
		const target = e.currentTarget as HTMLInputElement
		if (!target) return
		const available = target.dataset.available == 'true'
		const price = target.dataset.price || ''
		const instockEl = q.rs(
			'[data-uc-inventory-status-instock]',
			this.submitButton
		)
		const outstockEl = q.rs(
			'[data-uc-inventory-status-outstock]',
			this.submitButton
		)
		const priceEl = q.rs('[data-uc-price]', this.submitButton)
		if (!instockEl || !outstockEl || !priceEl) return

		instockEl.classList.toggle('hidden', !available)
		outstockEl.classList.toggle('hidden', available)
		priceEl.textContent = price

		this.submitButton.disabled = !available
	}

	checkValidation(input: HTMLInputElement) {
		const value = input.value.trim()

		if (!value) return false

		if (input.type === 'email') {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			return emailRegex.test(value)
		}

		return true
	}

	onChangeDetails(e: Event) {
		const target = e.currentTarget as HTMLInputElement
		if (!target) return

		target.classList.toggle('error', !this.checkValidation(target))
	}

	getSpinner() {
		return q.rs(SELECTORS.loadingOverlaySpinner, this)
	}

	onSubmitHandler(event: Event) {
		event.preventDefault()
		if (this.submitButton.disabled) return

		if (this.recipientControlInput) {
			this.recipientControlInput.value = 'true'
		}

		if (this.timezoneOffsetInput) {
			this.timezoneOffsetInput.value = new Date()
				.getTimezoneOffset()
				.toString()
		}

		let isValid = true

		this.contactDetailInputs.forEach((input) => {
			const validation = this.checkValidation(input)
			input.classList.toggle('error', !validation)
			if (!validation) isValid = false
		})

		if (!isValid) return

		this.submitButton.setAttribute('aria-disabled', 'true')
		this.submitButton.setAttribute(ATTRIBUTES.loading, '')
		this.getSpinner().classList.remove('hidden')

		const formData = new FormData(this.form)
		let formVariantId = formData.get('id') || formData.get('items[0][id]')
		if (!formVariantId) throw Error('No variant id found')
		const addedVariantId = parseInt(formVariantId.toString())

		addItemsToCart(formData, getDOMCartSectionApiIds())
			.then((cart) => {
				if ('status' in cart) {
					return
				}

				publish(PUB_SUB_EVENTS.cartUpdate, {
					source: 'product-form',
					productVariantId: addedVariantId,
				})
				renderResponseToCartDrawer(cart)
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {
				this.submitButton.removeAttribute(ATTRIBUTES.loading)
				this.submitButton.removeAttribute('aria-disabled')
				this.getSpinner().classList.add('hidden')
			})
	}
}
